import { createList, createMark } from '@lcifr/portable';
import { ListArrow } from './ListArrow';

export const ListArrowMark = createList('listArrow', ({ children }) => {
  return <ListArrow items={children} />;
});
